import { Box, Divider, List, ListItem, Paper, Tab, Tabs, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import HistoryMenu from '../components/history/HistoryMenu'
import HistoryFilter from '../components/history/HistoryFilter'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedTabType } from '../../store/Slices/historySlice'
import HistorySummary from '../components/HistorySummary'
import OrderSummary from '../components/OrderSummary'

export default function History() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState("Trades")
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
  const { symbols } = useSelector(state => state.watchlist)
  const filteredHistory = useSelector((state) => state.history.filteredHistory)
  const [searchQuery, setSearchQuery] = useState('');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
    console.log(newValue);
    dispatch(setSelectedTabType(newValue))
  }

  // const tabData = filteredHistory
  const tabData = filteredHistory.filter(item => {
    const query = searchQuery.toLowerCase()
    return (
      item.symbolName?.toLowerCase().includes(query) ||
      item.side?.toString().toLowerCase().includes(query) ||
      item.amount?.toString().includes(query) ||
      item.profitLoss?.toString().includes(query) ||
      item.type?.toString().toLowerCase().includes(query) ||
      new Date(item.dateTime).toLocaleString('sv-SE').toLowerCase().includes(query)
    )
  })

  const total = filteredHistory.length
  const canceled = filteredHistory.filter(item => item.status === 'CANCEL').length
  const typeMap = {
    1: "Deposit",
    2: "Adjustment",
    3: "Credit In",
    4: "Withdrawal",
    5: "Credit Out",
  };
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" py={1}>
        <Box flex={1} display="flex" justifyContent="center">
          <Typography sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('history')}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" pr={2} py={1} gap={1}>
          <HistoryMenu />
          <HistoryFilter />
        </Box>
      </Box>

      <Divider />
      <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", padding: 0, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <TextField size="small" variant="outlined" placeholder="Search here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1 }} />
          </Paper>
        </Box>
      </Box>

      <Tabs value={selectedTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
        <Tab label={t('trades')} value="Trades" />
        <Tab label={t('orders')} value="Orders" />
        <Tab label={t('transaction')} value="Transaction" />
      </Tabs>

      {(selectedTab === "Trades" || selectedTab === "Transaction") && <HistorySummary />}
      {selectedTab === "Orders" && <OrderSummary total={total} canceled={canceled} />}

      {tabData.length > 0 ? (
        <List sx={{ height: '100%', flex: 1, overflow: 'auto', paddingTop: 1, paddingBottom: isMobile ? 8 : 0 ,    overflowY: selectedTab === "Transaction" ? 'auto' : 'initial', maxHeight: selectedTab === "Transaction" ? 'calc(100vh - 300px)' : 'none',}}>
          {(selectedTab === "Trades" || selectedTab === "Orders") && tabData.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem alignItems="flex-start" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Box display="flex" alignItems="center">
                    <Typography fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : "var(--black)" }}>{item.symbolName}</Typography>
                    <Typography sx={{ ml: 1, color: item.side == 1 ? 'var(--primary)' : 'salmon', fontWeight: 'bold', textTransform: 'capitalize' }}>{item.side == 1 ? "Buy" : "Sell"}</Typography>
                  </Box>
                  <Typography variant="body2" color='textSecondary' sx={{ mt: 0.5 }}>{item?.amount ? item.amount.toFixed(decimalPlaces) : '0.00'} at {item?.openPrice ? item?.openPrice.toFixed(symbols[item?.symbolId].digits) : '0.00'}</Typography>
                </Box>

                <Box textAlign="right">
                  <Typography color='white' sx={{ fontWeight: 'bold' }}>{item.profitLoss}</Typography>
                  <Typography variant="body2" color='textSecondary'>{new Date(item.dateTime).toLocaleString('sv-SE').replace(' ', ' ')}</Typography>
                </Box>
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}

          {selectedTab === "Transaction" && tabData.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem alignItems="flex-start" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Box display="flex" alignItems="center">
                    <Typography color='primary' sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}> {typeMap[item.type] || "Unknown"}</Typography>
                  </Box>
                  <Typography variant="body2" color='textSecondary'>{new Date(item.dateTime).toLocaleString('sv-SE').replace(' ', ' ')}</Typography>

                </Box>

                <Box textAlign="right">
                  <Typography variant="body1" color='textSecondary' sx={{ mt: 0.5 }}>{item.amount.toFixed(decimalPlaces)}</Typography>

                </Box>
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
        </List>
      ) : (
        <Typography textAlign="center" mt={2} sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('noData')}</Typography>
      )}
    </>
  )
}
